import React, { useEffect, useState } from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { AppContext } from "../../core/ApplicationContextProvider";

function NNLeaseIntermediation(props) {
  const { toggle, agreementValue, setAgreementValue } = props;
  const [checkbox1, setCheckbox1] = useState(!!agreementValue);
  const [checkbox2, setCheckbox2] = useState(!!agreementValue);
  const [touched, setTouched] = useState(!!agreementValue);
  const context = React.useContext(AppContext);
  const { data } = context.details;
  const telefonNN = "";
  const emailNN = "contact@nnlease.ro";
  const agentName = data.agentName;
  const addressCityPostalCode =
    data.address + ", " + data.city + ", " + data.postalCode;
  const fiscalCode = data.fiscalCode;
  const agentPhoneNumber = data.agentPhoneNumber;
  const agentEmail = data.agentEmail;
  let classes = "checkmark";
  const errorMessage =
    "Trebuie sa bifezi ambele optiuni pentru a putea continua.";

  const handleApproveChange = () => {
    setTouched(true);
    setCheckbox1(!checkbox1);
  };

  const handleRejectChange = () => {
    setTouched(true);
    setCheckbox2(!checkbox2);
  };

  useEffect(() => {
    setAgreementValue(checkbox1 && checkbox2);
  }, [checkbox1, checkbox2]);

  const enableCloseModal = checkbox1 && checkbox2;

  return (
    <div>
      <ModalHeader
        toggle={toggle}
        tag="h6"
        cssModule={{
          "modal-title": "w-100 text-center",
          close: enableCloseModal ? "close" : "hide-close",
        }}
      >
        INFORMATII PRIVIND INTERMEDIARUL DE CREDITE / REPREZENTANTUL
        DESEMNAT{" "}
      </ModalHeader>
      <ModalBody className="tnr-12">
        <div>
          <span className="font-weight-bold" />
          <ul className="pt-3 square-list">
            <li>
              <span className="font-weight-bold">
                NN Lease S.R.L. („Intermediar de credite nelegat”/”NN Lease”)
              </span>
              , cu sediul in București, Sector 5, Str. Sergent Nuțu Ion nr. 44, Corp B, etaj 2,
              nr. de inregistrare in Registrul Comertului J40/9811/1999, cod
              unic de inregistrare fiscala RO12437824
              {telefonNN ? ", telefon " + telefonNN : ""}, e-mail {emailNN} este{" "}
              <span className="font-weight-bold">
                intermediar de credite nelegat
              </span>{" "}
              si presteaza servicii de intermediere exclusiv pentru{" "}
              <span className="font-weight-bold">
                ING Bank N.V. Sucursala Bucuresti („ING Bank”)
              </span>
              , institutie de credit cu sediul in Bucuresti, Str. Av. Popisteanu
              nr. 54A, Expo Business Park, cladirea 3, sector 1, cod postal
              012095, cod de inregistrare fiscala RO6151100, nr. de inregistrare
              in Registrul Comertului J40/16100/1994 si in Registrul
              Institutiilor de Credit: RBPJS-40-024/1999;
            </li>
            <li className="pt-3">
              {" "}
              <span className="border border-top-0 border-left-0 border-right-0 border-dark border-3">
                <span className="px-3">{agentName}</span>
              </span>{" "}
              („<span className="font-weight-bold">Reprezentant desemnat</span>
              ”), cu sediul{" "}
              <span className="border border-top-0 border-left-0 border-right-0 border-dark border-3">
                <span className="px-3">{addressCityPostalCode}</span>
              </span>
              , CUI/CNP{" "}
              <span className="border border-top-0 border-left-0 border-right-0 border-dark border-3">
                <span className="px-3">{fiscalCode}</span>
              </span>
              , telefon{" "}
              <span className="border border-top-0 border-left-0 border-right-0 border-dark border-3">
                <span className="px-3">{agentPhoneNumber}</span>
              </span>
              , e-mail{" "}
              <span className="border border-top-0 border-left-0 border-right-0 border-dark border-3">
                <span className="px-3">{agentEmail}</span>
              </span>{" "}
              este reprezentant desemnat{" "}
              <span className="font-weight-bold">
                exclusiv al NN Lease S.R.L.
              </span>{" "}
              si actioneaza in numele si sub raspunderea acestui intermediar de
              credite;
            </li>
            <li className="pt-3">
              Intermediarul de credite nelegat/Reprezentatul desemnat:
              <ul className="pt-3 empty-square-list">
                <li>
                  sunt inregistrati, in vederea prestarii de servicii de
                  intermediere credite, in Registrul Autoritatii Nationale
                  pentru Protectia Consumatorilor („ANPC”); informatii
                  suplimentare pot fi obtinute de la Punctul Unic de Informare
                  din cadrul ANPC, Bucuresti, Bdul. Aviatorilor nr. 72, sector 1
                  sau de pe site-ul ANPC,{" "}
                  <a
                    href="https://anpc.ro/articol/861/registru-1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://anpc.ro/articol/861/registru-1
                  </a>
                  ;
                </li>
                <li>NU presteaza servicii de consiliere;</li>
                <li>
                  Serviciile de intermediere oferite constau in prezentarea
                  catre consumatori de informatii cu privire la creditul
                  ipotecar al ING Bank si punerea in legatura a consumatorilor
                  interesati de un astfel de produs de credit cu ING Bank;
                </li>
                <li>
                  pentru serviciile de intermediere prestate: (i) nu percep
                  comisioane consumatorului; (ii) Reprezentantul Desemnat este
                  remunerat de NN Lease cu un comision in valoare de 500
                  lei/credit, daca ING Bank acorda consumatorului creditul in
                  legatura cu care au fost prestate servicii de intermediere;
                </li>
              </ul>
            </li>
            <li className="pt-3">
              Pentru eventuale reclamatii cu privire la serviciile de
              intermediere prestate, va puteti adresa fie direct Intermediarului
              de credite nelegat, fie Reprezentantului desemnat, la datele de
              contact mai sus mentionate. Daca nu sunteti satisfacut de
              raspunsul primit, va puteti adresa Autoritatii Nationale pentru
              Protectia Consumatorilor (Bdul. Aviatorilor nr. 72, sector 1,
              Bucuresti, <a href="mailto:office@anpc.ro">office@anpc.ro</a>) sau
              Centrului de Solutionare Alternativa a Litigiilor in Domeniul
              Bancar (str. Sevastopol nr.24, sector 1, Bucuresti, tel. 021 9414,{" "}
              <a
                href="https://csalb.ro"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.casalb.ro
              </a>
              ).
            </li>
          </ul>
        </div>

        <h5 className="mb-0 tnr-18">
          Clientul a luat la cunostinta ca informatiile sus mentionate trebuie
          sa ii fie furnizate cu cel putin 5 zile calendaristice inainte de
          prestarea oricarui serviciu de intermediere credite si ca are dreptul
          de a opta pentru reducerea acestui termen.
        </h5>
        <div className="pt-3">
          <div className="row pt-3">
            <div className="col-md-12">
              <div className="checkbox-container checkbox-warning-filled mb-2 pr-4">
                <div className="d-inline-block">
                  <label className="form-check-label checkbox-label d-inline-block">
                    <input
                      type="checkbox"
                      name="approve"
                      className={"form-check-input"}
                      onClick={handleApproveChange}
                      onChange={handleApproveChange}
                      checked={checkbox1}
                      value={checkbox1}
                    />
                    <span className={classes} />
                    <div className="field-label d-inline-block cursor-pointer h5 tnr-18 mb-0">
                      Am luat la cunostinta informatiile mai sus
                      mentionate.{" "}
                    </div>
                  </label>
                </div>
                <div className="col-md-12 text-danger ml-3">
                  {touched && !checkbox1 ? errorMessage : ""}
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="checkbox-container checkbox-warning-filled mb-2 pr-4">
                <div className="d-inline-block">
                  <label className="form-check-label checkbox-label d-inline-block">
                    <input
                      type="checkbox"
                      name="reject"
                      className={"form-check-input"}
                      onClick={handleRejectChange}
                      onChange={handleRejectChange}
                      checked={checkbox2}
                      value={checkbox2}
                    />
                    <span className={classes} />
                    <div className="field-label d-inline-block cursor-pointer h5 tnr-18 mb-0">
                      Doresc sa renunt la termenul de 5 zile
                      calendaristice.{" "}
                    </div>
                  </label>
                </div>
                <div className="col-md-12 text-danger ml-3">
                  {touched && !checkbox2 ? errorMessage : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" disabled={!enableCloseModal} onClick={toggle}>
          Închide
        </Button>
      </ModalFooter>
    </div>
  );
}

export default NNLeaseIntermediation;
